import React from 'react';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative text-center text-white overflow-hidden font-sans"
    >
      {/* Update for MDRP Conference */}
      {/* <div className="relative z-10 px-6 min-h-screen flex flex-col justify-center">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold tracking-tight leading-tight mb-8">
            What if your systems could adapt as fast as the industry changes?
          </h1>
          <p className="text-lg md:text-2xl text-gray-300 font-light mb-12">
            End to End Solutions for Commercial and Regulatory Market Access
          </p>
          <div className="max-w-xl w-full mx-auto mb-20">

            <button
              onClick={() => {
                const section = document.getElementById("mdrp");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="border border-blue-500 text-blue-300 hover:bg-blue-800 font-medium py-3 px-6 rounded-xl transition duration-200"
            >
              MDRP 2025
            </button>

          </div>
          <SimpleTestimonials />
        </div>
      </div> */}

      {/* Updates for the GTN Conference */}
      <div className="relative z-10 px-6 min-h-screen flex flex-col justify-center">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold tracking-tight leading-tight mb-6">
            OpenPharma
          </h1>

          <h2 className="text-2xl md:text-4xl font-medium tracking-tight leading-snug mb-8 text-gray-200">
            Aligning Accounting, Finance, and Market Access Together Around a
            Single Source of Truth
          </h2>

          <p className="text-lg md:text-2xl text-gray-300 font-light mb-12">
            Reconciling ERP - RCM - GTN to gain visibility and confidence in
            your data
          </p>
        </div>
      </div>
    </section>
  );
}
